module.exports = __webpack_public_path__ + "media/images/modular-kitchen-img-2-6cc50202c014170c920a3f05030193d6.jpg";